import React, { Suspense } from 'react';
import { CenteredSpinner } from '@components/ui/feedback/CenteredSpinner';

import { lazyWithRetry } from '../../utils/lazyWithRetry';

// Lazy load for code splitting
const FirstEncounterView = lazyWithRetry(() => import('./components/FirstEncounterView'));

/**
 * First Encounter Page
 *
 * Special view for first-time encounter creation with guided workflow.
 * Uses lazy loading for code splitting.
 */
export const FirstEncounterPage: React.FC = () => {
  return (
    <Suspense fallback={<CenteredSpinner />}>
      <FirstEncounterView />
    </Suspense>
  );
};

export default FirstEncounterPage;
